import { Text } from '@frontend/design-system';

type SectionInfoProps = {
  label: string;
  value: string;
};

export const SectionInfo = ({ label, value }: SectionInfoProps) => {
  return (
    <div>
      <Text size='small' color='subdued'>
        {label}
      </Text>
      <Text weight='bold'>{value}</Text>
    </div>
  );
};
